'use strict';

import { Error } from '@src/components/PasswordInput/interfaces/error.interface';

const EMAIL_VALIDATION_REGEX =
  /^[-!#$%&'*+/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-?\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;

// Regex is based on the recommended special characters by OWASP:
// https://owasp.org/www-community/password-special-characters
export const RECRUITER_PASSWORD_SPECIAL_CHARACTERS_REGEX =
  /\s|!|”|#|\$|%|&|’|\(|\)|\*|\+|,|-|\.|\/|:|;|<|=|>|\?|@|\[|\|\]|\^|_|`|\{|\||\}|~/;
export const RECRUITER_PASSWORD_UPPERCASE_CHARACTERS_REGEX = /[A-Z]/;
export const RECRUITER_PASSWORD_LOWERCASE_CHARACTERS_REGEX = /[a-z]/;
export const RECRUITER_PASSWORD_NUMBER_CHARACTERS_REGEX = /[0-9]/;
export const RECRUITER_FORBIDDEN_EMAIL_REGEX = /@(gmail|hotmail|live|yahoo|gmx)\.(com|net)$/;

// Thanks to:
// http://fightingforalostcause.net/misc/2006/compare-email-regex.php
// http://thedailywtf.com/Articles/Validating_Email_Addresses.aspx
// http://stackoverflow.com/questions/201323/what-is-the-best-regular-expression-for-validating-email-addresses/201378#201378
export const validateEmail = function (email: string): boolean {
  if (email.length > 254) {
    return false;
  }

  if (!EMAIL_VALIDATION_REGEX.test(email)) {
    return false;
  }

  // Further checking of some things regex can't handle
  const parts = email.split('@');

  if (parts[0].length > 64) {
    return false;
  }

  const domainParts = parts[1].split('.');

  if (
    domainParts.some(function (part) {
      return part.length > 63;
    })
  ) {
    return false;
  }

  return true;
};

export const isNotWorkEmail = (email: string): boolean => {
  return RECRUITER_FORBIDDEN_EMAIL_REGEX.test(email);
};

export const isPasswordLengthValid = (value: string): boolean => {
  return value.length >= 10;
};

export const doesContainSpecialCharacter = (value: string): boolean => {
  return RECRUITER_PASSWORD_SPECIAL_CHARACTERS_REGEX.test(value);
};

export const doesContainUppercase = (value: string): boolean => {
  return RECRUITER_PASSWORD_UPPERCASE_CHARACTERS_REGEX.test(value);
};

export const doesContainLowercase = (value: string): boolean => {
  return RECRUITER_PASSWORD_LOWERCASE_CHARACTERS_REGEX.test(value);
};

export const doesContainNumber = (value: string): boolean => {
  return RECRUITER_PASSWORD_NUMBER_CHARACTERS_REGEX.test(value);
};

export const getPasswordErrorMessage = (password: string): Error | undefined => {
  const errors: Error = {};

  if (!RECRUITER_PASSWORD_SPECIAL_CHARACTERS_REGEX.test(password)) {
    errors.hasNotSpecialCharacter = true;
  }

  if (!RECRUITER_PASSWORD_UPPERCASE_CHARACTERS_REGEX.test(password)) {
    errors.hasNotUppercase = true;
  }

  if (!RECRUITER_PASSWORD_LOWERCASE_CHARACTERS_REGEX.test(password)) {
    errors.hasNotLowercase = true;
  }

  if (!RECRUITER_PASSWORD_NUMBER_CHARACTERS_REGEX.test(password)) {
    errors.hasNotNumber = true;
  }

  if (password.length < 10) {
    errors.hasNotEnoughLength = true;
  }

  return Object.keys(errors).length === 0 ? undefined : errors;
};
